import { Customer } from '../globals/customer';
import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

export const updateLeaseApplication = async ({ ...customer }: Partial<Customer>) => {
  const endpoint = ENDPOINT.LeaseAppUpdate;

  const response = await apiHelper(endpoint, {
    method: 'PATCH',
    body: JSON.stringify({ customer }),
  });

  const resp = await response.json();

  return response.ok ? resp : void 0;
};
